import React from 'react'

import { shouldSkipBrowserCompatibilityCheck } from '@flowwai-frontend/shared/constants'

import {
   BROWSER_NOT_COMPATIBLE_IMAGE,
   BROWSER_COMPATIBILITY_VIEW_IMAGE,
   SUPPORTED_CHROME_VERSION
} from '../../constants/BrowserConstants'
import useGetBrowserDetails from '../../hooks/useGetBrowserDetails/useGetBrowserDetails.bowser'

import BrowserNotCompatibleView from '../BrowserNotCompatibleView/BrowserNotCompatibleView'

interface Props {
   appLogo: string
   children: React.ReactElement

   logoClassName?: string
   containerClassName?: string
   headerContainerClassName?: string
}

const BrowserCompatibility = (props: Props): React.ReactElement => {
   const {
      children,
      appLogo,
      logoClassName,
      containerClassName,
      headerContainerClassName
   } = props

   const { getBrowserCompatibility } = useGetBrowserDetails()
   const { isBrowserSupported, isVersionSupported } = getBrowserCompatibility()

   if (shouldSkipBrowserCompatibilityCheck) {
      return children
   }

   if (!isBrowserSupported) {
      //TODO: move hard coded strings to i18n
      const title = 'Please use Google Chrome to access the Portal.'
      const description =
         'We recommend using Google Chrome for the best experience. Other browsers are not supported.'

      return (
         <BrowserNotCompatibleView
            appLogo={appLogo}
            logoClassName={logoClassName}
            containerClassName={containerClassName}
            headerContainerClassName={headerContainerClassName}
            title={title}
            infoImageURL={BROWSER_NOT_COMPATIBLE_IMAGE}
         />
      )
   }

   if (!isVersionSupported) {
      //TODO: move hard coded strings to i18n
      const title = 'Update your Browser'
      const description = `For best experience use chrome version ${SUPPORTED_CHROME_VERSION} or above.`

      return (
         <BrowserNotCompatibleView
            appLogo={appLogo}
            logoClassName={logoClassName}
            containerClassName={containerClassName}
            headerContainerClassName={headerContainerClassName}
            title={title}
            description={description}
            infoImageURL={BROWSER_COMPATIBILITY_VIEW_IMAGE}
         />
      )
   }

   return children
}

export default BrowserCompatibility
